<template>
  <div class="userItem">
    <!-- -->
    <div class="imgBox">
      <img :src="userInfo.avatar" class="img" alt="">
    </div>
    <div class="infoBox">
      <div class="name">{{userInfo.contactName}}</div>
      <div class="com_position">{{userInfo.company}} · {{userInfo.position}}</div>
    </div>
    <div class="controll">
      <div class="cancel" @click="disagree">{{$t('lang.t130')}}</div>
      <div class="confirm" @click="agree">{{$t('lang.t129')}}</div>
    </div>
  </div>
</template>

<script>
import { agreeAddContact, disagreeAddContact } from '@/api/interNational'
export default {
  name: 'Useritem',
  props: {
    userInfo: {
      type: Object,
      default: {},
    },
    showControll: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },

  mounted() {},

  methods: {
    async agree() {
      let params = {
        remark: '',
        requestSource: this.userInfo.requestSource,
        tagId: [],
        targetUid: this.userInfo.targetUid,
      }
      agreeAddContact({}, params)
        .then((res) => {
          this.$toast(this.$t('lang.t131'))
          this.$emit('refresh')
        })
        .catch((err) => {})
    },
    disagree() {
      disagreeAddContact({}, this.userInfo)
        .then((res) => {
          this.$toast(this.$t('lang.t132'))
          this.$emit('refresh')
        })
        .catch((err) => {})
    },
  },
}
</script>


<style lang="less" scoped>
.userItem {
  width: 100%;
  height: 75px;
  padding: 0 12px;
  display: flex;
  margin-bottom: 20px;
  .imgBox {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    margin-right: 10px;
    .img {
      width: 100%;
      border-radius: 50%;
      height: 100%;
    }
  }
  .infoBox {
    width: calc(100% - 164px);
    height: 100%;
    // border-bottom: 1px solid #d8d8d8;
    .name {
      font-size: 17px;
      color: #262626;
      font-weight: bold;
    }
    .com_position {
      font-size: 14px;
      color: #262626;
      margin-top: 3px;
    }
  }
  .controll {
    font-size: 14px;
    // border-bottom: 1px solid #d8d8d8;
    .cancel {
      width: 70px;
      height: 27px;
      border-radius: 6px;
      border: 1px solid #00c4c9;
      color: #00c4c9;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 27px;
    }
    .confirm {
      width: 70px;
      height: 27px;
      border-radius: 6px;
      background: #00c4c9;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 27px;
      margin-top: 10px;
    }
  }
}
</style>